<template>
  <div class="content">
    <!-- <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Paginated Tables</h2>
    </div> -->
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Lista de Funcionários
          </h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar funcionário"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
              <div class="row w-100 mt-3">
                <div
                  class="col d-flex justify-content-center justify-content-sm-end flex-wrap"
                >
                  <div class="mx-1 my-1">
                    <base-button
                      type="success"
                      class="animation-on-hover fixed-size-btn"
                      @click="$router.push('/cadastrarFuncionarios/1')"
                    >
                      Cadastrar Funcionário
                    </base-button>
                  </div>
                  <div class="mx-1 my-1">
                    <base-button
                      type="success"
                      class="animation-on-hover fixed-size-btn"
                      @click="openModal"
                    >
                      Importar Funcionários
                    </base-button>
                  </div>
                  <div class="mx-1 my-1">
                    <base-button
                      class="animation-on-hover fixed-size-btn"
                      @click="mostrarModal = true"
                    >
                      Exportar Funcionários
                    </base-button>
                  </div>
                  <div class="mx-1 my-1">
                    <base-button
                      class="animation-on-hover fixed-size-btn"
                      @click="baixarModeloExcel"
                    >
                      Baixar Modelo Excel
                    </base-button>
                  </div>
                </div>
              </div>
            </div>

            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <!-- <base-button
                    @click.native="handleLike(props.$index, props.row)"
                    class="like btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-heart-2"></i>
                  </base-button> -->
                  <el-tooltip
                    content="Editar"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="handleEdit(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>

                  <el-tooltip
                    content="Horário Limite"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click="handleHoraLimite(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-watch-time"></i>
                    </base-button>
                  </el-tooltip>
                  <modal :show.sync="dialogHorarioLimite">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Hórario limite
                      </h4>
                    </template>
                    <div>
                      <h5 class="text-left">
                        <strong>Funcionário:</strong>
                        {{ payloadHoraLimite.funcionario.nome }}
                      </h5>
                      <el-select
                        class="select-success col-sm-12 pagination-select"
                        v-model="horarioSelecionado"
                      >
                        <el-option
                          v-for="item of horariosLimite"
                          :key="item.value"
                          class="select-success"
                          :label="item.label"
                          :value="item.value"
                          selected
                          >{{ item.label }}</el-option
                        >
                      </el-select>

                      <div class="row" style="margin-top: 10px;">
                        <p class="text-left"><b>Atenção:</b></p>
                        <p class="text-left">
                          Caso este funcionário saia exemplo <b>03:00</b> da
                          manhã, configure para <b>04:00</b> por segurança
                        </p>
                      </div>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="dialogHorarioLimite = false"
                        >Fechar</base-button
                      >
                      <base-button type="success" @click="salvarHoraLimite()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>

                  <el-tooltip
                    content="Autorizar Registro"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click="handlePermission(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-mobile"></i>
                    </base-button>
                  </el-tooltip>

                  <modal :show.sync="dialogPermissao">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Autorização de Registro de Ponto
                      </h4>
                    </template>
                    <div class="container">
                      <div class="row">
                        <div class="col-12">
                          <h5 class="text-left">
                            <strong>Funcionário:</strong>
                            {{ payloadPermissao.funcionario.nome }}
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <label
                            for="postoTrabalho"
                            class="form-label  text-left w-100"
                            :class="erros.postos === true ? 'text-danger' : ''"
                            >Filial/Unidades/Posto de trabalho
                            autorizados</label
                          >
                          <el-select
                            multiple
                            class="select-success pagination-select w-100"
                            :class="erros.postos === true ? 'has-danger' : ''"
                            size="large"
                            v-model="payloadPermissao.postos"
                            collapse-tags
                            placeholder="Selecione as opções"
                          >
                            <el-option
                              v-for="option in postos"
                              class="select-info"
                              :value="option.id"
                              :label="option.local"
                              :key="option.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>

                    <template slot="footer">
                      <base-button
                        type="danger"
                        :disabled="isLoading"
                        @click="fecharPermissao()"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="enviarPermisao()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>

                  <el-tooltip
                    content="Demitir/Suspender Funcionário"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-alert-circle-exc"></i>
                    </base-button>
                  </el-tooltip>
                  <modal :show.sync="dialogDemitirFuncionario">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Demitir/Suspender Funcionário
                      </h4>
                    </template>
                    <div class="container">
                      <div class="row">
                        <div class="col-12">
                          <h5 class="text-left">
                            <strong>Funcionário:</strong>
                            {{ selectRow.nome }}
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 text-left">
                          <base-input
                            label="Data da demissão (Ex: dd/mm/aaaa)"
                            type="date"
                            placeholder="Data da Demissão"
                            v-model="demitir.data"
                            @blur="validarDataDemissao"
                          >
                          </base-input>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 text-left">
                          <base-input
                            label="Motivo"
                            type="text"
                            placeholder="Motivo"
                            v-model="demitir.motivo"
                          >
                          </base-input>
                        </div>
                      </div>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="dialogDemitirFuncionario = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        @click="demitirFuncionario()"
                        :disabled="
                          demitir.data.length > 9 && demitir.motivo.length > 4
                            ? false
                            : true
                        "
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} funcionários.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
    <ImportacaoFuncionarios
      :visible.sync="showImportModal"
      @success="handleImportSuccess"
    />
    <ModalExportarUsuarios
      :show="mostrarModal"
      @close="mostrarModal = false"
      @exportar="exportarSelecionados"
    />
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import jwt from "jsonwebtoken";
import ImportacaoFuncionarios from "@/components/Funcionario/ImportacaoFuncionarios.vue";
import ModalExportarUsuarios from "@/components/Funcionario/ModalExportarFuncionarios.vue";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
    ImportacaoFuncionarios,
    ModalExportarUsuarios,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      dadosUsuario: "",
      horariosLimite: [
        {
          value: "01:00:00",
          label: "01:00",
        },
        {
          value: "02:00:00",
          label: "02:00",
        },
        {
          value: "03:00:00",
          label: "03:00",
        },
        {
          value: "04:00:00",
          label: "04:00",
        },
        {
          value: "05:00:00",
          label: "05:00",
        },
        {
          value: "06:00:00",
          label: "06:00",
        },
        {
          value: "07:00:00",
          label: "07:00",
        },
        {
          value: "08:00:00",
          label: "08:00",
        },
        {
          value: "09:00:00",
          label: "09:00",
        },
        {
          value: "10:00:00",
          label: "10:00",
        },
        {
          value: "11:00:00",
          label: "11:00",
        },
        {
          value: "12:00:00",
          label: "12:00",
        },
      ],
      showImportModal: false,
      mostrarModal: false,
      payloadPermissao: {
        permissao: "Sim",
        postos: [],
        funcionario: "",
      },
      payloadHoraLimite: {
        hora_limite: "",
        funcionario: "",
      },
      postos: [],
      funcionarioSelecionado: [],
      selectRow: [],
      horarioSelecionado: "05:00:00",
      dialogDemitirFuncionario: false,
      dialogPermissao: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      demitir: {
        data: "",
        motivo: "",
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["nome"],
      tableColumns: [
        {
          prop: "nome",
          label: "Funcionário",
          minWidth: 200,
        },
      ],
      // tableData: users,
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      erros: {
        postos: "",
      },
    };
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarFuncionarios();
    this.listarPostos();
    this.$root.$on("funcaoCadastrarFuncionario", (params) => {
      alert("ccccc");
      setTimeout(() => {
        this.cadastrarFuncionario(params);
      }, 1000);
    });

    this.$root.$on("funcaoEditarFuncionario", (params) => {
      setTimeout(() => {
        this.editarFuncionario(params);
      }, 1000);
    });

    // this.notifyVue('top', 'center');
  },
  methods: {
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },
    openModal() {
      this.showImportModal = true;
    },
    handleImportSuccess() {
      this.listarFuncionarios();
    },
    carregarFuse() {
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["nome"],
        threshold: 0.3,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    handleEdit(index, row) {
      this.funcionarioSelecionado = row;
      let w1 = jwt.sign({ data: { idFuncionario: row.id } }, "qXTflPwOaD", {
        expiresIn: "1h",
      });
      this.$router.push(`/editarFuncionarios/${w1}/2`);
    },

    handleDelete(index, row) {
      this.dialogDemitirFuncionario = true;
      this.selectRow = row;
    },

    editarFuncionario(params) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: params.setDB,
        cpf: params.cpf.replace(/[. - / - -]/g, ""),
        numero_pis: params.numero_pis,
        data_pis: params.data_pis,
        nome: params.nome,
        numero_matricula_ctps: params.numero_matricula_ctps,
        codigo: params.codigo.toString(),
        endereco: params.endereco,
        complemento: params.complemento,
        bairro: params.bairro,
        cep: params.cep.replace(/[. - / - -]/g, ""),
        estado: params.estado,
        cidade: params.cidade,
        telefone: params.telefone.replace(/[. - ( - ) - / - -]/g, ""),
        email: params.email,
        escolaridade: params.escolaridade,
        sexo: params.sexo,
        filiacao_pai: params.filiacao_pai,
        filiacao_mae: params.filiacao_mae,
        data_nascimento: params.data_nascimento ? params.data_nascimento : null,
        ctps: params.ctps,
        ctps_serie: params.ctps_serie,
        expedicao: params.expedicao,
        rg: params.rg,
        orgao_expedicao: params.orgao_expeditor,
        data_expedicao: params.data_expedicao ? params.data_expedicao : null,
        titulo_numero: params.titulo_numero,
        titulo_zona: params.titulo_zona,
        titulo_secao: params.titulo_secao,
        cert_reservista_ra: params.cert_reservista_ra,
        certificado_reservista_categoria:
          params.certificado_reservista_categoria,
        certificado_reservista_serie: params.certificado_reservista_serie,
        data_adimissao: params.data_adimissao ? params.data_adimissao : null,
        horas_contradadas_mes: params.horas_contradadas_mes
          ? params.horas_contradadas_mes
          : null,
        funcao: params.funcao,
        departamento: params.departamento,
        contribuicao_sindical_data: params.contribuicao_sindical_data,
        contribuicao_sindical_valor: params.contribuicao_sindical_valor,
        valor_plano_saude: params.valor_plano_saude
          ? params.valor_plano_saude
          : null,
        nr_conta_bancaria: params.nr_conta_bancaria,
        banco: params.banco,
        id_funcionario: params.id_funcionario,
      };

      this.axios
        .post("/api/empregado/atualizarDadosEmpregado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Dados alterados com sucesso!",
            "success",
          );
          setTimeout(() => {
            // location.reload()
            th.$router.push("/pesquisarEmpregados");
          }, 2000);
        })
        .catch(() => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao alterar dados!", "error");
          // location.reload()
          /* setTimeout(() => {
          th.$router.push("/pesquisarEmpregados")
        }, 2000) */
        });
    },

    demitirFuncionario() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.selectRow.id,
        motivo: this.demitir.motivo,
        data_demissao: this.demitir.data,
      };

      this.axios
        .post("/api/empregado/demitirEmpregado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then(() => {
          th.isLoading = false;
          th.dialogDemitirFuncionario = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Funcionário demitido com successo!",
            "success",
          );

          setTimeout(() => {
            location.reload();
          }, 2000);
        })
        .catch(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Falha ao demitir funcionário!",
            "error",
          );
          // warning, error, success, info, and question
        });
    },

    listarFuncionarios() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.tableData = response.data.data.dados;
          th.carregarFuse();
        })
        .catch(() => {
          th.isLoading = false;
        });
    },

    handlePermission(index, row) {
      this.payloadPermissao.funcionario = row;
      this.dialogPermissao = true;

      this.listarPostosFuncionario();
    },

    handleHoraLimite(index, row) {
      // this.payloadHoraLimite.funcionario = row;
      // this.dialogHorarioLimite = true;
      // this.horarioSelecionado = row.hora_limite ? row.hora_limite : "05:00:00";
      this.funcionarioSelecionado = row;
      let w1 = jwt.sign({ data: { idFuncionario: row.id } }, "qXTflPwOaD", {
        expiresIn: "1h",
      });
      this.$router.push(`/horarioLimite/${w1}`);
    },

    salvarHoraLimite() {
      this.dialogHorarioLimite = false;
      this.payloadHoraLimite.hora_limite = this.horarioSelecionado;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        hora_limite: this.payloadHoraLimite.hora_limite,
        id_funcionario: this.payloadHoraLimite.funcionario.id,
      };

      const that = this;

      this.axios
        .post("/api/empregado/atualizarHoraLimite", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then(() => {
          that.searchQuery = "";
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Sucesso",
            "Hora limite atualizada com successo!",
            "success",
          );

          that.listarFuncionarios();
        })
        .catch(() => {
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao atualizar Hora limite!",
            "error",
          );
        });
    },

    fecharPermissao() {
      this.limparPermisao();
      this.dialogPermissao = false;
    },

    limparPermisao() {
      this.payloadPermissao = {
        permissao: "Não",
        postos: [],
        funcionario: "",
      };
      this.erros.postos = "";
    },

    listarPostos() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };

      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.postos = response.data.data.dados;
        })
        .catch((err) => {
          th.postos = [];
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar postos de trabalho!",
            "error",
          );
        });
    },

    listarPostosFuncionario() {
      const th = this;
      const bodyFormData = {
        cpf_empregado: this.payloadPermissao.funcionario.cpf,
      };
      this.axios
        .post("/api/login/loginEmpregadoApenasCpf", bodyFormData)
        .then((response) => {
          if (response.data.data.dados && response.data.data.dados.length > 0)
            th.payloadPermissao.postos = response.data.data.dados.map(
              (d) => d.ID_EMPREGADOR,
            );
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar postos de trabalho!",
            "error",
          );
        });
    },
    enviarPermisao() {
      if (this.payloadPermissao.postos.length === 0) {
        this.erros.postos = true;
      } else {
        //se tiver posto marcado entao autoriza
        this.isLoading = true;
        this.payloadPermissao.permissao = "SIM";
        this.erros.postos = false;

        const bodyFormData = {
          setDB: this.$cookies.get("db"),
          id_empregador: this.payloadPermissao.postos,
          id_empregado: this.payloadPermissao.funcionario.id,
        };

        const that = this;

        this.axios
          .post("/api/empregado/cadastrarAoPostosDeTabalho", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            console.log(response);
            that.isLoading = false;
            that.showSwal(
              "auto-close",
              "Sucesso",
              "Autorização enviada com successo!",
              "success",
            );
          })
          .catch((err) => {
            that.isLoading = false;
            console.log(err);
            that.showSwal(
              "auto-close",
              "Erro",
              "Erro ao listar postos de trabalho!",
              "error",
            );
          });
      }
    },
    baixarModeloExcel() {
      try {
        this.isLoading = true;
        // Caminho relativo ao arquivo na pasta public
        const filePath = "/templates/dados_funcionarios.xlsx";
        // Criar um link temporário para download
        const link = document.createElement("a");
        link.href = filePath;
        link.setAttribute("download", "dados_funcionarios.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.error("Erro ao baixar o modelo Excel:", error);
        this.showSwal(
          "auto-close",
          "Erro",
          "Não foi possível baixar o modelo Excel.",
          "error",
        );
      }
    },
    async exportarSelecionados(campos) {
      try {
        this.isLoading = true;
        this.mostrarModal = false;
        const response = await this.axios.post(
          "/api/empregado/exportarFuncionarios",
          {
            camposSelecionados: campos,
            setDB: this.$cookies.get("db"),
          },
          {
            responseType: "blob",
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "usuarios.xlsx");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.error("Erro ao exportar usuários:", err);
      } finally {
        this.isLoading = false;
      }
    },
    validarDataDemissao() {
      const anoAtual = this.moment().year();

      const dataValida = this.moment(this.demitir.data).isValid();

      const ano = Number(this.demitir.data.split("-")[0]);

      if (!dataValida || ano < 1900 || ano > anoAtual) {
        this.showSwal(
          "auto-close",
          "Data inválida",
          "Informe uma data válida.",
          "error",
        );
        this.demitir.data = "";
      }
    },
    moment: function(data) {
      return moment(data);
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
.fixed-size-btn {
  width: 240px;
  height: 48px;
  font-size: 14px;
  padding: 0;
}
</style>
